import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { SubscriptionTag } from "./SubscriptionTag";

@Entity({one: "subscription", many: "subscriptions"})
export class Subscription {

	@Field()
	public id: ID;

	@Field()
	public completion: any;

	@Field()
	public completedOn?: string;

	@Field()
	public score?: number;

	@Field()
	public maxScore?: number;

	@Field()
	public lastVisited?: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public timeSpent?: number;

}

// tslint:disable-next-line
export class PreTestSubscription {

	@Field()
	public id: ID;

	@Field()
	public completion: any;

	@Field()
	public completedOn?: string;

	@Field()
	public score?: number;

	@Field()
	public maxScore?: number;

	@Field()
	public lastVisited?: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public timeSpent?: number;

	// separate entity for this field
	@Field({entity: SubscriptionTag})
	public tags?: SubscriptionTag[];

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Subscription.ts